import * as z from "zod/v4";

export const getUserPin = {
  name: "getUserPin" as const,
  input: z.object({ userId: z.string() }),
  output: z.object({ pin: z.string().nullish() }),
};
